<template lang="pug">
.generic-wrapper
  .container
    h1.title Listen
    .sub-headline Hier können Sie die aktuellen Annreiselisten und Reinigungslisten ansehen.

    MenuItems
      MenuItem(name="Anreiseliste" description="Hier sehen Sie alle Anreisegäste und können diese ausrucken." @click="$router.push({name: 'ListsArrivals'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            path(d='M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2')
            rect(x='8' y='2' width='8' height='4' rx='1' ry='1')
      MenuItem(name="Abreiseliste" description="Hier sehen Sie alle Abreisegäste und können diese ausrucken." @click="$router.push({name: 'ListsDepartures'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            path(d='M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2')
            rect(x='8' y='2' width='8' height='4' rx='1' ry='1')
      MenuItem(name="Endreinigungsliste" description="Hier sehen Sie die priorisierte Reinigungsliste und können diese ausrucken." @click="$router.push({name: 'ListsCleaners'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            path(d='M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2')
            rect(x='8' y='2' width='8' height='4' rx='1' ry='1')
      MenuItem(name="Reinigungsübersicht" description="Hier können Sie kommende Reinigungen ansehen." @click="$router.push({name: 'ListsCleanersHeatmap'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            path(d='M21.21 15.89A10 10 0 1 1 8 2.83')
            path(d='M22 12A10 10 0 0 0 12 2v10z')
      MenuItem(name="Alle Buchungen" description="Hier sehen Sie alle Buchungen." @click="$router.push({name: 'ListsBookings'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            path(d='M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2')
            rect(x='8' y='2' width='8' height='4' rx='1' ry='1')
      MenuItem(name="Rechnungen" description="Hier sehen Sie alle Rechnungen." @click="$router.push({name: 'ListsInvoices'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            path(d='M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2')
            rect(x='8' y='2' width='8' height='4' rx='1' ry='1')


      //- MenuItem(name="Neue Buchungen" description="Hier sehen Sie alle neuen Buchungen." @click="$router.push('/data/offers')")
      //-   template(v-slot:img)
      //-     svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
      //-       path(d='M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2')
      //-       rect(x='8' y='2' width='8' height='4' rx='1' ry='1')
      //- MenuItem(name="Fällige Zahlungen" description="Hier sehen Sie alle nicht vollständig bezahlte Buchungen." @click="$router.push('/data/offers')")
      //-   template(v-slot:img)
      //-     svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
      //-       path(d='M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2')
      //-       rect(x='8' y='2' width='8' height='4' rx='1' ry='1')
</template>

<script>
import MenuItem from "@/components/atoms/MenuItem.vue";
import MenuItems from "@/components/molecules/MenuItems.vue";

export default {
  components: {
    MenuItem,
    MenuItems
  }
};
</script>